import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { DateModule } from '../../../common/date/date.module';
import { AttachmentPreviewDialogComponent } from './attachment-preview-dialog.component';

@NgModule({
  exports: [AttachmentPreviewDialogComponent],
  imports: [DateModule, I18nModule, CommonModule, AttachmentPreviewDialogComponent],
})
export class AttachmentPreviewDialogModule {}

export { AttachmentPreviewDialogComponent } from './attachment-preview-dialog.component';
